import { call, fork, put, all, takeLatest, select } from 'redux-saga/effects';
import { selectRecipes } from './selectors';
import * as actions from './actions';
import { getType } from 'typesafe-actions';
import { fetchRecipe, updateRecipe, createRecipe, fetchRecipes, pickRecipes } from './services';
import { SagaAction } from 'Types';
import { Recipe, Grocery } from './model';
import { push } from 'connected-react-router'

function* submitRecipeChoicesSuccessSaga(action: SagaAction<Grocery[]>) {
  const groceries = action.payload;
  yield put(actions.addGroceryList(groceries));
  yield put(push('/grocery_list'))
}

function* submitRecipeChoicesSuccessListener() {
  yield takeLatest(getType(actions.submitRecipeChoices.success), submitRecipeChoicesSuccessSaga);
}

function* submitRecipeChoicesRequestSaga(action: SagaAction<string[]>) {
  const pickRecipesService = (ids: string[]) => pickRecipes(ids);
  try {
    const response = yield call(pickRecipesService, action.payload);
    const { groceries } = yield response.json();
    if (response.status === 200) {
      yield put(actions.submitRecipeChoices.success(groceries));
    }
  } catch (error) {
    put(actions.submitRecipeChoices.failure(error));
  }
}

function* submitRecipeChoicesRequestListener() {
  yield takeLatest(getType(actions.submitRecipeChoices.request), submitRecipeChoicesRequestSaga)
}


function* createRecipeSuccessSaga(action: SagaAction<Recipe>) {
  yield put(actions.add(action.payload));
  yield put(push("/recipes"));
}

function* createRecipeSuccessListener() {
  yield takeLatest(getType(actions.createRecipe.success), createRecipeSuccessSaga)
}

function* createRecipeRequestSaga(action: SagaAction<Recipe>) {
  const createRecipeService = (recipe: Recipe) =>
    createRecipe(recipe);
  try {
    const response = yield call(createRecipeService, action.payload);
    if (response.status === 200) {
      const { recipe } = yield response.json();
      yield put(actions.createRecipe.success(recipe));
    } else {
      throw new Error("Failed to save recipe");
    }
  } catch (error) {
    put(actions.createRecipe.failure(error));
  }
}

function* createRecipeRequestListener() {
  yield takeLatest(getType(actions.createRecipe.request), createRecipeRequestSaga)
}
function* updateRecipeSuccessSaga(action: SagaAction<Recipe>) {
  console.log("Updated Recipe: ", action.payload);
  yield put(actions.update(action.payload));
  yield put(push("/recipes"));
}

function* updateRecipeSuccessListener() {
  yield takeLatest(getType(actions.updateRecipe.success), updateRecipeSuccessSaga)
}

function* updateRecipeRequestSaga(action: SagaAction<Recipe>) {
  console.log("Update: ", action.payload);
  const updateRecipeService = (recipe: Recipe) =>
    updateRecipe(recipe);
  try {
    const response = yield call(updateRecipeService, action.payload);
    if (response.status === 200) {
      const { recipe } = yield response.json();
      yield put(actions.updateRecipe.success(recipe));
    } else {
      throw new Error("Failed to save recipe");
    }
  } catch (error) {
    put(actions.updateRecipe.failure(error));
  }
}

function* updateRecipeRequestListener() {
  yield takeLatest(getType(actions.updateRecipe.request), updateRecipeRequestSaga)
}

function* fetchRecipeSuccessSaga(action: SagaAction<Recipe>) {
  const recipe = action.payload;
  yield put(actions.add(recipe));

  const id = <string>recipe.id;
  if (id) {
    yield put(actions.setActiveRecipe(id));
  }
}

function* fetchRecipeSuccessListener() {
  yield takeLatest(getType(actions.fetchRecipe.success), fetchRecipeSuccessSaga);
}

function* fetchRecipeSaga(action: SagaAction<string>) {
  const id = action.payload;
  const recipes = yield select(selectRecipes);
  if (recipes[id]) {
    yield put(actions.setActiveRecipe(action.payload));
  } else {
    const fetchRecipeService = (id: string) =>
      fetchRecipe(id);
    try {
      const response = yield call(fetchRecipeService, action.payload);
      if (response.status === 200) {
        const { recipe } = yield response.json();
        yield put(actions.fetchRecipe.success(recipe));
      }
    } catch (error) {
      yield put(actions.fetchRecipe.failure(error));
    }
  }
}

function* fetchRecipeListener() {
  yield takeLatest(getType(actions.fetchRecipe.request), fetchRecipeSaga);
}

function* fetchRecipesSuccessSaga(action: SagaAction<Recipe[]>) {
  const recipes = action.payload;
  yield all(recipes.map(recipe => put(actions.add(recipe))));
}

function* fetchRecipesSuccessListener() {
  yield takeLatest(getType(actions.fetchRecipes.success), fetchRecipesSuccessSaga);
}

function* fetchRecipesSaga(action: SagaAction<string>) {
  const fetchRecipesService = () =>
    fetchRecipes();
  try {
    const response = yield call(fetchRecipesService);
    if (response.status === 200) {
      const { recipes } = yield response.json();
      yield put(actions.fetchRecipes.success(recipes));
    } else {
      throw new Error("Could not fetch Recipes")
    }
  } catch (error) {
    yield put(actions.fetchRecipes.failure(error));
  }
}

function* fetchRecipesListener() {
  yield takeLatest(getType(actions.fetchRecipes.request), fetchRecipesSaga);
}

export const recipeSagas = [
  fork(fetchRecipeListener),
  fork(fetchRecipeSuccessListener),
  fork(updateRecipeRequestListener),
  fork(updateRecipeSuccessListener),
  fork(fetchRecipesListener),
  fork(fetchRecipesSuccessListener),
  fork(createRecipeRequestListener),
  fork(createRecipeSuccessListener),
  fork(submitRecipeChoicesRequestListener),
  fork(submitRecipeChoicesSuccessListener)
]